import { usePermission } from "../hooks/usePermission";
import { Route, Redirect } from 'react-router-dom';

export const ProtectedRoute = ({ permission, children, ...rest }) => {
    const { can } = usePermission();

    const handleRouteRender = () => ({ location }) => {
        if (can(permission)) {
          return children;
        }

        return <Redirect to="/login" state={{ from: location }} />;
    };
  
    return (
        <Route
            {...rest}
            render={handleRouteRender()}
        />
    );
};